export enum PayloadTypes {
	Input,
	Output,
}
